module.exports = __webpack_public_path__ + "static/img/RACKPACK_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RACKPACK_1.png
// module id = 57oH
// module chunks = 0